import { IWorkLog, IWorkLogCreate } from "@wingspanhq/payments/dist/interfaces";
import { WSService } from "../utils/WSService";

const service = new WSService("/payments/work-log");

export async function createWorkLog(
  request: IWorkLogCreate
): Promise<IWorkLog> {
  const { data } = await service.post("", request);
  return data;
}

export type ApiQueryListWorkLogs = {
  "filter[payerPayeeEngagementId][=]"?: string;
  "filter[startDate][=]"?: Date;
  "filter[startDate][>]"?: Date;
  "filter[startDate][>=]"?: Date;
  "filter[startDate][<]"?: Date;
  "filter[startDate][<=]"?: Date;

  "filter[endDate][=]"?: Date;
  "filter[endDate][>]"?: Date;
  "filter[endDate][>=]"?: Date;
  "filter[endDate][<]"?: Date;
  "filter[endDate][<=]"?: Date;
  "filter[endDate][exists]"?: boolean;

  "filter[invoiceId][exists]"?: boolean;
  "filter[payerId]"?: string;
  "filter[payeeId]"?: string;

  page?: {
    size?: number;
    number?: number;
  };
};

export async function listWorkLogs(
  query?: ApiQueryListWorkLogs
): Promise<IWorkLog[]> {
  const { data } = await service.get("", { params: query });
  return data;
}

export async function getWorkLog(workLogId: string): Promise<IWorkLog> {
  const { data } = await service.get("/" + workLogId);
  return data;
}

export async function convertWorkLog(workLogId: string): Promise<IWorkLog> {
  const { data } = await service.post("/" + workLogId + "/convert");
  return data;
}
